class StickyHeader {
  constructor() {
    this.header = document.querySelector('[data-sticky-addToCart]');
    this.productSection = document.querySelector('[data-product-section]');
    
    if (!this.header || !this.productSection) return;
    
    // Initialize gfpbarHeight
    this.gfpbarHeight = 0;
    
    // Wait for GF Pro toolbar to load
    this.waitForGFProToolbar();
    
    this.headerHeight = this.header.offsetHeight;
    this.productSectionBottom = this.productSection.getBoundingClientRect().bottom;
    
    this.init();
  }
  
  waitForGFProToolbar() {
    const checkForToolbar = () => {
      const toolbar = document.querySelector('.gfp_toolbar_style');
      if (toolbar && toolbar.clientHeight > 0) {
        this.gfpbarHeight = toolbar.clientHeight;
        const height = this.gfpbarHeight + 'px';
        document.documentElement.style.setProperty('--go-proBar-height', height);
        console.log('GF Pro toolbar found with height:', this.gfpbarHeight);
      } else {
        setTimeout(checkForToolbar, 200);
      }
    };
    
    checkForToolbar();
  }
  
  init() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));
  }
  
  handleScroll() {
    const productSectionBottom = this.productSection.getBoundingClientRect().bottom;
    const isMobile = window.innerWidth <= 768;
    let transformHeight = 'translateY(90%)';
    let transformHeightmobile = 'translateY(42%)';
    
    
    if (this.gfpbarHeight > 0) {
      transformHeight = 'translateY(120%)';
    }
    
    if (productSectionBottom <= 0) {
      this.header.style.transform = isMobile ? transformHeightmobile : transformHeight;
    } else {
      this.header.style.transform = 'translateY(-100%)';
    }
  }
  
  handleResize() {
    this.headerHeight = this.header.offsetHeight;
    this.productSectionBottom = this.productSection.getBoundingClientRect().bottom;
    
    // Re-check GF Pro toolbar height on resize
    this.updateGFProHeight();
  }
  
  updateGFProHeight() {
    const toolbar = document.querySelector('.gfp_toolbar_style');
    if (toolbar && toolbar.clientHeight > 0) {
      this.gfpbarHeight = toolbar.clientHeight;
      console.log('Updated GF Pro height:', this.gfpbarHeight);
    }
  }
}

const stickyAtcHeader = new StickyHeader();